import { makeStyles } from '../../../../../../styles';
import { ROW_SIZE_PIXELS } from './MenuContent.constants';
export const useStyles = makeStyles((theme) => {
    const commonListItemStyles = {
        cursor: 'pointer',
        padding: theme.spacing(1),
        borderRadius: theme.spacing(1),
        '&:hover': {
            backgroundColor: theme.colors.gray[100],
        },
    };
    return {
        root: {
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
        },
        icon: {
            color: theme.colors.text[600],
        },
        divider: {
            margin: theme.spacing(1),
            borderStyle: 'dashed',
        },
        operatorSelect: {
            width: '100%',
            marginBottom: theme.spacing(1),
        },
        selectAll: Object.assign(Object.assign({}, commonListItemStyles), { display: 'flex', gap: theme.spacing(1), alignItems: 'center' }),
        listItem: Object.assign(Object.assign({}, commonListItemStyles), { display: 'flex', gap: theme.spacing(1), alignItems: 'center', padding: theme.spacing(0, 1), width: 'calc(100% - 16px) !important' }),
        checkbox: {
            padding: 0,
        },
        label: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
        createOption: Object.assign(Object.assign({}, commonListItemStyles), { padding: theme.spacing(1, 1.5) }),
        noOptions: {
            padding: theme.spacing(1),
        },
        listDivider: {
            display: 'flex',
            flexDirection: 'column',
            paddingTop: ROW_SIZE_PIXELS / 2,
        },
        loadingIndicator: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(255, 255, 255, 0.67)',
            '& .MuiCircularProgress-root': {
                height: theme.spacing(5),
                width: theme.spacing(5),
            },
        },
    };
});
//# sourceMappingURL=MenuContent.styles.js.map